/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from 'react'
import {
  makeStyles,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
  Box,
  IconButton,
} from '@material-ui/core'
import Cookies from 'js-cookie'
import useAxios from '@hooks/useAxios'
import AddDialogForm from '@containers/Layout/Crud/AddDialogForm'
import EditDialogForm from '@containers/Layout/Crud/EditDialogForm'
import { useSnackbar } from 'notistack'
import { yupResolver } from '@hookform/resolvers/yup'
import { rules, schema } from '@config/yup.schema'

import { Alert, Pagination } from '@material-ui/lab'
import { ReactComponent as SearchIcon } from '@assets/images/svg/search.svg'
import AddCircle from '@material-ui/icons/AddCircle'
import EditSharpIcon from '@material-ui/icons/EditSharp'
import dayjs from 'dayjs'
import { Visibility } from '@material-ui/icons'
import { resellerApiWithToken } from '@api/baseApi'
// import { getCollectionApi } from './api'
import FormDialog from './FormDialog'
import ShowDialog from './ShowDIalog'
import BankFormDialog from '../../../BankAccount/Form'
import { postBankApi, editBankApi } from './api'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1.5rem 2rem',
    background: '#fff',
    borderRadius: 10,
    marginBottom: '2rem',
    '& p': {
      fontWeight: 600,
      lineHeight: '27px',
    },
  },
  table: {
    marginTop: '0.625rem',
    paddingBottom: '2rem',
  },
  percentage: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  searchField: {
    '& .MuiInputBase-root': {
      padding: '0.375rem 0.75rem',
      border: '1px solid #C4C4C4',
      borderRadius: 5,
    },
    '& .MuiInputAdornment-positionStart': {
      paddingBottom: 0,
    },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: 0,
    },
  },
  dateField: {
    '& .MuiInputBase-root': {
      padding: '0.375rem 0.75rem',
      border: '1px solid #C4C4C4',
      borderRadius: 5,
      width: 170,
      marginRight: '1rem',
    },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: 0,
    },
  },
  filterForm: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '1rem',
  },
  loading: {
    padding: '1rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  resetButton: {
    fontSize: '0.875rem',
    height: 38,
  },
}))

const resolver = yupResolver(schema({
  // bank: rules.mixed,
  name: rules.stringRequired,
  number: rules.number,
}))

const TableWithdraws = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(true)
  const [withdraws, setwithdraws] = useState()
  const { enqueueSnackbar } = useSnackbar()
  const [open, setOpen] = useState(false)
  const [openBank, setOpenBank] = useState(false)
  const [show, setShow] = useState(false)
  const [showId, setShowId] = useState()
  const [params, setParams] = useState({
    page: 1,
    per_page: 10,
  })

  const scope = Cookies.get('scope')

  let path

  if (scope === 'reseller') {
    path = '/resellers/withdraws'
  } else {
    path = '/affiliates/withdraws'
  }

  const affiliateBankPath = '/affiliates/bank_accounts'

  const bankAccounts = useAxios(resellerApiWithToken, 'get', affiliateBankPath)

  const formatParamBank = (value) => {
    const newParams = {
      bank_id: value?.bank?.id,
      name: value?.name,
      number: value?.number,
    }
    return newParams
  }

  const postDataBank = async (postParams) => {
    try {
      const { status, data: { data } } = await postBankApi(formatParamBank(postParams), affiliateBankPath)

      if (status === 200) {
        setOpenBank(false)
        enqueueSnackbar('berhasil menambah data', {
          variant: 'success',
        })
        bankAccounts.fetch()
      } else if (Array.isArray(data)) {
        data.map((item) => enqueueSnackbar(item, {
          variant: 'error',
        }))
      } else {
        enqueueSnackbar('Maaf, terjadi kesalahan', {
          variant: 'error',
        })
      }
    } catch (error) {
      enqueueSnackbar('Maaf, terjadi kesalahan saat menyimpan data', {
        variant: 'error',
      })
    }
  }

  const putDataBank = async (currentId, putParams) => {
    try {
      const { status, data: { data } } = await editBankApi(currentId, formatParamBank(putParams), affiliateBankPath)

      if (status === 200) {
        setOpenBank(false)
        enqueueSnackbar('berhasil merubah data', {
          variant: 'success',
        })
        bankAccounts.fetch()
      } else if (Array.isArray(data)) {
        data.map((item) => enqueueSnackbar(item, {
          variant: 'error',
        }))
      } else {
        enqueueSnackbar('Maaf, terjadi kesalahan', {
          variant: 'error',
        })
      }
    } catch (error) {
      enqueueSnackbar('Maaf, terjadi kesalahan saat merubah data', {
        variant: 'error',
      })
    }
  }

  const fetchWithdraw = async () => {
    try {
      setLoading(true)
      const { status, data } = await resellerApiWithToken.get(path, { params })

      if (status === 200) {
        setwithdraws(data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const resetFilter = () => {
    setParams({
      page: 1,
      per_page: 10,
    })
  }

  useEffect(() => {
    fetchWithdraw()
  }, [params])

  useEffect(() => {
    if (scope !== 'reseller') bankAccounts.fetch()
  }, [])

  return (
    <div className={classes.root}>
      <p>Permintaan Withdraw</p>
      <div className={classes.filterForm}>
        <Box display="flex" alignItems="center">
          <TextField
            placeholder="Cari nomor"
            value={params.number || ''}
            onChange={(e) => setParams({ ...params, number: e.target.value })}
            className={classes.searchField}
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            }}
            variant="outlined"
          />
          <Button
            color="primary"
            variant="contained"
            style={{ marginLeft: 4 }}
            startIcon={<AddCircle />}
            onClick={() => setOpen(true)}
          >
            Permintaan Withdraw
          </Button>
          {
            scope !== 'reseller' && (
              <Button
                color="primary"
                variant="contained"
                style={{ marginLeft: 4 }}
                startIcon={bankAccounts.data && bankAccounts.data[0] ? <EditSharpIcon /> : <AddCircle />}
                onClick={() => setOpenBank(true)}
              >
                { bankAccounts.data && bankAccounts.data[0] ? 'Ubah Akun Bank' : 'Buat Akun Bank' }
              </Button>
            )
          }
        </Box>
        <Button
          color="primary"
          variant="contained"
          className={classes.resetButton}
          onClick={() => resetFilter()}
        >
          Reset
        </Button>
      </div>
      {!loading ? (
        <Fragment>
          {withdraws && withdraws.data?.length > 0 ? (
            <Fragment>
              <TableContainer className={classes.table}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>Nomor WD</TableCell>
                      <TableCell>Tanggal Dibuat</TableCell>
                      <TableCell>Biaya Admin</TableCell>
                      <TableCell>Jumlah</TableCell>
                      <TableCell>Tanggal Transfer</TableCell>
                      <TableCell>Tanggal Approve</TableCell>
                      <TableCell>Aksi</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {withdraws.data.map((withdraw, index) => (
                      <TableRow key={withdraw.id}>
                        <TableCell>{(((params.page - 1) * 10) + (index + 1))}</TableCell>
                        <TableCell>{withdraw.number}</TableCell>
                        <TableCell>{dayjs(withdraw.created_at).locale('id').format('DD MMMM YYYY') }</TableCell>
                        <TableCell>{withdraw.formatted_admin_fee}</TableCell>
                        <TableCell>{withdraw.formatted_amount}</TableCell>
                        <TableCell>{withdraw?.transfered_at ? dayjs(withdraw.transfered_at).locale('id').format('DD MMMM YYYY') : '-'}</TableCell>
                        <TableCell>{withdraw?.approved_at ? dayjs(withdraw.approved_at).locale('id').format('DD MMMM YYYY') : '-'}</TableCell>
                        <TableCell>
                          <IconButton onClick={() => {
                            setShowId(withdraw.id)
                            setShow(true)
                          }}
                          >
                            <Visibility />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Pagination
                count={withdraws.pagination.total_pages}
                page={params.page}
                onChange={(_event, value) => setParams({ ...params, page: value })}
                shape="rounded"
              />
            </Fragment>
          ) : (
            <Alert variant="outlined" severity="warning">
              Data yang di cari masih kosong / tidak ditemukan
            </Alert>
          )}
        </Fragment>
      ) : (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      )}
      <FormDialog
        open={open}
        onClose={() => setOpen(false)}
        fetchWithdraw={fetchWithdraw}
      />
      <ShowDialog
        open={show}
        onClose={() => setShow(false)}
        showId={showId}
      />
      {
        scope !== 'reseller' && openBank && bankAccounts.data && !bankAccounts.data[0] && (
          <AddDialogForm
            open={openBank}
            title="Akun Bank"
            toggleDialog={() => setOpenBank(false)}
            formComponent={BankFormDialog}
            postData={postDataBank}
            resolver={resolver}
          />
        )
      }
      {
        scope !== 'reseller' && openBank && bankAccounts.data && bankAccounts.data[0] && (
          <EditDialogForm
            open={openBank}
            title="Akun Bank"
            toggleDialog={() => setOpenBank(false)}
            formComponent={BankFormDialog}
            putData={putDataBank}
            editId={bankAccounts.data[0].id}
            resolver={resolver}
            showLoading={false}
            defaultValues={{
              bank: bankAccounts.data[0].bank,
              name: bankAccounts.data[0].name,
              number: bankAccounts.data[0].number,
            }}
          />
        )
      }
    </div>
  )
}

export default TableWithdraws
